/**
 * @surfline/quiver-react v12.14.9 2020-10-22
 */

import React from 'react';
import 'prop-types';
import classNames from 'classnames';
import SpotDetails from '../SpotDetails/SpotDetails.js';
import SpotListCTAThumbnail from '../SpotListCTAThumbnail/SpotListCTAThumbnail.js';
import SpotThumbnail from '../SpotThumbnail/SpotThumbnail.js';

const getBackgroundImg = spot => spot.cameras[0] ? spot.cameras[0].stillUrl : spot.thumbnail;

const getClassName = mobileCard => classNames({
  'quiver-spot-list-item__container': true,
  'quiver-spot-list-item__container--mobile-card': mobileCard
});

const SpotListItem = ({
  spot,
  units,
  showPremiumCamCTA,
  mobileCard
}) => /*#__PURE__*/React.createElement("div", {
  className: getClassName(mobileCard)
}, /*#__PURE__*/React.createElement("div", {
  style: {
    backgroundImage: `url('${getBackgroundImg(spot)}')`
  },
  className: "quiver-spot-list-item"
}, /*#__PURE__*/React.createElement("div", {
  className: "quiver-spot-list-item__container"
}, showPremiumCamCTA ? /*#__PURE__*/React.createElement(SpotListCTAThumbnail, {
  spot: spot
}) : /*#__PURE__*/React.createElement(SpotThumbnail, {
  windDirection: spot.wind.direction,
  windSpeed: spot.wind.speed,
  units: units,
  hasCamera: spot.cameras.length > 0
}), /*#__PURE__*/React.createElement(SpotDetails, {
  showPremiumCamCTA: showPremiumCamCTA,
  spot: spot,
  units: units
}))));

SpotListItem.defaultProps = {
  showPremiumCamCTA: false,
  mobileCard: false
};

export default SpotListItem;
//# sourceMappingURL=SpotListItem.js.map
